import React from "react";
import Gallery1 from "../../Assets/Images/gallery1.png";
import Gallery2 from "../../Assets/Images/gallery2.png";
import Gallery3 from "../../Assets/Images/gallery3.png";
import Gallery4 from "../../Assets/Images/gallery4.png";

const ExploreGallery = () => {
  return (
    <div className="bg-[#f3fbfd] py-10 lg:py-16">
      <div className="max-w-7xl mx-auto px-6 relative">
        {/* Grid layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* LEFT - Large Building Image */}
          <div className="lg:col-span-7 xl:col-span-7">
            <div className="rounded-lg overflow-hidden shadow-[0_20px_30px_rgba(16,24,40,0.08)] min-h-[300px] sm:min-h-[380px] lg:h-[560px]">
              <img
                src={Gallery1}
                alt="Large building"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* RIGHT - Heading + description */}
          <div className="lg:col-span-5 xl:col-span-5 flex flex-col justify-start">
            <div className="pt-2 lg:pt-6">
              <h2 className="text-xl sm:text-2xl md:text-3xl xl:text-4xl font-semibold text-gray-900 leading-tight">
                Explore Our <span className="text-[#FF6B35]">Gallery</span>
              </h2>

              <p className="mt-3 text-gray-500 text-sm sm:text-base lg:text-lg max-w-xl">
                On Our Journey Toward Redefining Community Living, Covenants Has Been Both A
                Milestone And A Fresh Beginning.
              </p>
            </div>

            {/* spacer to allow overlapping card space */}
            <div className="hidden lg:block flex-1" />
          </div>
        </div>

        {/* Overlapping card — absolute on lg+, normal flow on mobile */}
        <div className="mt-8 lg:mt-0 lg:absolute inset-x-6 lg:inset-x-auto lg:left-1/2 transform lg:-translate-x-1/3 lg:w-[68%] lg:top-[40%] z-30">
          <div className="bg-white rounded-2xl shadow-[0_20px_45px_rgba(2,6,23,0.12)] p-5 sm:p-6 lg:p-8">
            {/* Thumbnails row */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6">
              {[Gallery2, Gallery3, Gallery4].map((img, idx) => (
                <div
                  key={idx}
                  className="rounded-lg overflow-hidden aspect-[4/3] shadow-sm"
                >
                  <img
                    src={img}
                    alt={`Gallery thumbnail ${idx + 1}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Rating row */}
            <div className="mt-6 lg:mt-8 flex items-center gap-4">
              {/* Icon */}
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-orange-500 flex-shrink-0 shadow-md">
                <svg
                  className="w-6 h-6 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>

              {/* Rating text */}
              <div>
                <div className="text-2xl sm:text-3xl font-semibold text-gray-900">
                  4.1
                </div>
                <div className="flex items-center mt-1 gap-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <svg
                      key={i}
                      className={`w-4 h-4 ${
                        i < 4 ? "text-orange-400" : "text-gray-300"
                      }`}
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom spacing for mobile */}
        <div className="h-12 lg:h-0" />
      </div>
    </div>
  );
};

export default ExploreGallery;